import { IReportElement } from "@monorepo/reports/src/views/ReceiptsFromOikView/types/reportElement";

export const convertApiItemToUi = (item: IReportElement): IReportElement => ({
  ...item,
  statusTK: item.statusTK,
});
